import { Component, OnInit } from '@angular/core';
import { dogBodylanguage } from './dogBodyLanguage';
import { catBodylanguage } from './catBodyLanguage';

@Component({
  selector: 'app-behaviors',
  templateUrl: './behaviors.page.html',
  styleUrls: ['./behaviors.page.scss'],
})
export class BehaviorsPage implements OnInit {
  actionList: { action: string; meaning: string }[];
  filter = 'dogs';
  constructor() { }

  ngOnInit() {
    this.filter = localStorage.getItem('animalFilter') || 'dogs';
    this.loadBehaviors()
  }
  filterBehaviors() {
    localStorage.setItem('animalFilter', this.filter);
    this.loadBehaviors();
  }
  loadBehaviors() {
    if (this.filter === 'dogs') {
      this.actionList = dogBodylanguage;
    } else {
      this.actionList = catBodylanguage;
    }
    this.actionList.sort((a, b) => a.action.localeCompare(b.action));
  }
}
